import {addToArrayUnique} from './addToArrayUnique';

/**
 * Safely add to an array if it's not already in the array.\
 * This will NOT modify the original array.
 *
 * @typeParam T - The array item type (infered)
 *
 * @param array Array to add to
 * @param toAdd Item to add to array
 * @returns New array with item added if it wasn't already in the array
 *
 * @example
 * const array = [1, 2, 3];
 * const newArray1 = addToArrayUnique(array, 3); // [1, 2, 3]
 * const newArray2 = addToArrayUnique(array, 4); // [1, 2, 3, 4]
 */
export const safeAddToArrayUnique = <T>(array: T[], toAdd: T) =>
	addToArrayUnique([...array], toAdd);

export default safeAddToArrayUnique;
